import { Col } from "@amzn/stencil-react-components/layout";
import { Link } from "@amzn/stencil-react-components/link";
import { Text } from "@amzn/stencil-react-components/text";
import IconExternalLink from "@amzn/stencil-react-icons/icons/icon-external-link";
import React, { FC } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import { LAB_WIKI_URL } from "@/common/constants/external-links.constants";

export const BaselineSummary: FC = () => (
  <Col gridGap="S100" margin={{ top: "S300", bottom: "S300" }} dataTestId="baselining-summary">
    <Text color="neutral70">{getString("campaigns.summary")}</Text>
    <Link href={LAB_WIKI_URL} target="_blank" icon={<IconExternalLink aria-hidden={true} />}>
      {getString("campaigns.summaryLinkText")}
    </Link>
  </Col>
);
